import { Controller, useFormContext } from 'react-hook-form'

import { FF2, SecuredInput, Validators } from 'ui/components'
import { SarEdit } from '~bank-bsa-reporting/types'

export const TIN = ({ index }: { index: number }) => {
  const { control } = useFormContext<SarEdit>()

  return (
    <Controller
      name={`institutionActivitiesInfo.${index as 0}.tin`}
      control={control}
      rules={{
        validate: Validators.required.field
      }}
      render={({ field }) => (
        <FF2
          required
          label="59. TIN"
          field={field}
          input={(props) => <SecuredInput {...props} maxLength={25} data-qa="59. TIN" />}
        />
      )}
    />
  )
}
